import { all } from 'redux-saga/effects';
import { watchContact } from './contact';
import { dataSaga } from './data';

function* rootSaga() {
  yield all([watchContact(), dataSaga()]);
}

export default rootSaga;
